import { useNewsUnreadCount } from '../../hooks/useNewsReader';
import type { NewsPlatform } from '../../types/news.types';
import { NewsSilentBoundary } from './NewsSilentBoundary';

function Badge({ platform, className }: { platform: NewsPlatform; className: string }) {
  const count = useNewsUnreadCount(platform);
  if (count === 0) return null;
  return (
    <span
      className={`tw-bg-red-500 tw-text-white tw-text-xs tw-font-bold tw-min-w-[20px] tw-h-5 tw-rounded-full tw-inline-flex tw-items-center tw-justify-center tw-px-1.5 ${className}`}
      aria-label={count > 1 ? `${count} nouveautés non lues` : '1 nouveauté non lue'}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}

/**
 * Pastille du nombre de nouveautés non lues, à poser dans une entrée de menu.
 * Rien n'est rendu à 0, pendant le chargement ou si l'appel échoue.
 */
export function NewsUnreadBadge({ platform, className = '' }: { platform: NewsPlatform; className?: string }) {
  return (
    <NewsSilentBoundary>
      <Badge platform={platform} className={className} />
    </NewsSilentBoundary>
  );
}
